import { connect } from 'react-redux';

import ShoppingLists from '../components/ShoppingLists';
import { closeShoppingListsModal } from 'apps/shoppingLists/actions/shoppingLists';

export default connect(
  state => ({
    shoppingListsOpened: state.shoppingLists.modal,
  }),
  { onClose: closeShoppingListsModal }
)(ShoppingLists);
